import { render, staticRenderFns } from "./send-mail.vue?vue&type=template&id=10a41c50&scoped=true&"
import script from "./send-mail.vue?vue&type=script&lang=js&"
export * from "./send-mail.vue?vue&type=script&lang=js&"
import style0 from "./send-mail.vue?vue&type=style&index=0&id=10a41c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a41c50",
  null
  
)

export default component.exports